import { render } from "./DownloadSection.vue?vue&type=template&id=5f16b684&scoped=true"
import script from "./DownloadSection.vue?vue&type=script&lang=js"
export * from "./DownloadSection.vue?vue&type=script&lang=js"

import "./DownloadSection.vue?vue&type=style&index=0&id=5f16b684&scoped=true&lang=css"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/VibeLab/XP/Xp mircosite/xp-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f16b684"]])

export default __exports__